import { AdminsPageLayout } from "../AdminsPageLayout/AdminsPageLayout";

export const AdminEventsPage = () => (
  <AdminsPageLayout selector="admin-events">
    <div>todo: admin events</div>
  </AdminsPageLayout>
);
